import Grid from '@material-ui/core/Grid';
import { useEffect, useState, memo } from 'react';
import TextField from '@mui/material/TextField';


const SangerRowWell = memo((props) => {
    const index = props.index;
    const rowLengthX = Math.floor(index / 8);
    const rowLengthY = index % 8;
    var startX = rowLengthX + 1;
    let sX = startX.toString();
    let sY = String.fromCharCode(rowLengthY + 65);
    const well = sY + sX;
  
  return (
    <Grid item>
    <TextField
    variant="outlined"
    disabled={true}
    value={well}
    sx={{ width: 50, '& .MuiInputBase-root': { height: 40, borderRadius: 0},'& legend': { display: 'none' },
    '& fieldset': { top: 0 }, 
    "& .MuiInputBase-input": {
        textAlign: 'center'
      }
}}
    />
    </Grid>
        );
    },
    (prevProps, nextProps) => {
        return prevProps.id === nextProps.id && prevProps.index === nextProps.index;
    });

export default SangerRowWell;